export default __webpack_public_path__ + "static/media/jvc-jvt.1a688771.webp";